// Spain
export const locale = {
    lang: 'es',
    data: {
        TRANSLATOR: {
            SELECT: 'Elige tu idioma',
            ENTITY: 'Entidad',
        },
        DATEPICKER: {
            IntervalOfDates: 'Intervalo de Fechas',
            Initial: 'Inicio',
            End: 'Fin',
            Year: 'Año',
            Month: 'Mes',
            Day: 'Día',
            Select: 'Seleccione',
        },
        ACTION: {
            Cancel: 'Cancelar',
            Back: 'Volver',
            Confirm: 'Confirmar',
            Clear: 'Limpiar',
            Export: 'Exportar',
            Filter: 'Filtrar',
            Search: 'Buscar',
        },
        MENU: {
            NEW: 'nuevo',
            ACTIONS: 'Comportamiento',
            CASHIER: 'Cajero',
            CREATE_POST: 'Crear nueva publicación',
            PAGES: 'Pages',
            FEATURES: 'Caracteristicas',
            APPS: 'Aplicaciones',
            DASHBOARD: 'Tablero',
            ACCOUNTRECEIVING: 'Cuentas a Recibir',
            FILERETURN: 'Devolver Archivos',
            COLLECTORFILE: 'Archivo de cobradores',
            MANAGE: 'Administrar',
            IMPORT: 'Importar',
            BACKPREVIOUSMENU: 'Volver al menú anterior',
            FILEREMITANCE: 'Envío de archivos',
            FILEGENERATE: 'Generar archivo',
            TOOLS: 'Herramientas',
            ROUNDING: 'Redondeo',
            MANAGEMENT: 'Administración',
            CHANGECONTRACT: 'Cambio de contrato',
            RECORDSCARD: 'Registro de Tarjeta',
            CREDITCARDRECURRENCE: 'Recurrencias Tarjetas de Crédito',
            RECURRINGCARD: 'Tarjeta Recurrente',
            DEVELOPMENT: 'Desarrollo',
            RECURRENCEMANAGEMENT: 'Manejo de la recurrencia',
            TASKS: 'Tareas',
            FINANCIAL: 'Financiero',
            MANAGEBUGS: 'Administrar errores',
            DUE_DATE_IN_BATCHES: 'Fecha de Vencimento em Lotes',
            BILLET: 'Boleto',
            REPORT: 'Informes',
            FATURATION: 'Faturación',
            BACK: 'Volver',
            MappingCurrentAccountBillet: 'Mapeamento de Boletos',
            ACCOUNTING: 'Contabilidad',
            ACCOUNTING_BATCH: 'Lote Contable',
            RECEIVING: 'Recebimento',
            RECEIVINGS: 'Recebimentos',
            PIX: 'Recebimento Pix',
        },

        CUSTOMLIST: {
            FILEMANAGE: {
                COLUNS: {
                    fileName: 'Nombre del archivo',
                    date: 'Fecha',
                    quantityLines: 'Qtd. de Líneas',
                    processStatusString: 'Status',
                },
                VALUES: {
                    StandBy: 'Colocarse',
                },
            },
            FILEAUDIT: {
                COLUNS: {
                    creditDate: 'Fecha  de Crédito',
                    valuePaid: 'Valor Pago',
                    iterestValue: 'Tarifa',
                    error: 'Error',
                    listPossibleSolutions: 'Solución',
                    returnDate: 'Fecha de regreso',
                    legalEntityDescription: 'Escuela',
                    beneficiaryName: 'Alumno',
                    fee: 'Multa',
                    interest: 'Interes',
                    honorario: 'Honorários',
                },
                VALUES: {
                    ExpirationOfTerm: 'Vencimiento del Plazo',
                },
            },
        },
        AUTH: {
            GENERAL: {
                OR: 'O',
                SUBMIT_BUTTON: 'Enviar',
                NO_ACCOUNT: 'No tienes una cuenta?',
                SIGNUP_BUTTON: 'Regístrate',
                FORGOT_BUTTON: 'Se te olvidó tu contraseña',
                BACK_BUTTON: 'Espalda',
                PRIVACY: 'Intimidad',
                LEGAL: 'Legal',
                CONTACT: 'Contacto',
            },
            LOGIN: {
                TITLE: 'Crear una cuenta',
                BUTTON: 'Registrarse',
            },
            FORGOT: {
                TITLE: 'Contraseña olvidada?',
                DESC: 'Ingrese su correo electrónico para restablecer su contraseña',
                SUCCESS: 'Your account has been successfully reset.',
            },
            REGISTER: {
                TITLE: 'Sign Up',
                DESC: 'Enter your details to create your account',
                SUCCESS: 'Your account has been successfuly registered.',
            },
            INPUT: {
                EMAIL: 'Email',
                FULLNAME: 'Fullname',
                PASSWORD: 'Password',
                CONFIRM_PASSWORD: 'Confirm Password',
                USERNAME: 'Usuario',
            },
            VALIDATION: {
                INVALID: '{{name}} is not valid',
                REQUIRED: '{{name}} is required',
                MIN_LENGTH: '{{name}} minimum length is {{min}}',
                AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
                NOT_FOUND: 'The requested {{name}} is not found',
                INVALID_LOGIN: 'The login detail is incorrect',
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_FIELD: 'Field is not valid',
            },
        },
        STATUS: {
            All: 'Todas',
            Add: 'Añadir',
            Alter: 'Cambio',
            Cancel: 'Cancelar',
            WritOff: 'Eliminar',
        },
        CardRecurrence: 'Tarjeta Recurrente',
        NoRecurrence: 'Sin Recurrencia',
        Scheduled: 'Programado',
        Confirmed: 'Confirmado',
        Error: 'Error',
        Processing: 'Processando',
        RetirementPending: 'Pendiente de Bajar',
        NoneFinancialAgreement: 'Nenhum Convênio Financeiro',
        Unauthorized: 'No Autorizado',
        NoCapture: 'Sin Captura',
        All: 'Todos',
        ENUM: {
            NoRecurrence: 'Sin recurrencia',
            Scheduled: 'Programado',
            Confirmed: 'Confirmado',
            Error: 'Error',
            Processing: 'Processando',
            RetirementPending: 'Pendiente de Bajar',
            NoneFinancialAgreement: 'Nenhum Convênio Financeiro',
            Unauthorized: 'No Autorizado',
            NoCapture: 'Sin Captura',
            All: 'Todos',
            Opened: 'Abierto',
            Closed: 'Cerrado',
            Accounted: 'Contable',
        },
        SELECT: {},

        MESSAGES: {
            HOMEMESSAGE:
                'Estamos preparando contenido nuevo para ti. Mientras tanto, puede navegar por otras pantallas a través del menú del lado izquierdo.',
            WELCOME: 'Bem venido',
        },
        CASHIERMANAGEMENT: {
            dateOpen: 'Fecha de abertura',
            dateClose: 'Fecha de cierre',
            user: 'Usuario',
            numberCasher: 'Número de Caja',
            entity: 'Entidad',
            statusCashier: 'Estado de caja',
            clear: 'Limpiar',
            filter: 'Filtrar',
            export: 'Exportar',
            thereIsNoDataToLoad: 'No hay datos para cargar',
            deposit: 'Depositar',
            deposit2: 'Depositar',
            accountsBank: 'Cuentas Bancarias',
            accountBank: 'Cuenta Bancaria',
            depositDate: 'Fecha de Deposito',
            value: 'A depositar',
            add: 'Agregar',
            date: 'Fecha',
            thereIsNoDepositAdded: 'No hay depósito agregado',
            amountToDeposit: 'La cantidad a depositar',
            depositedAmount: 'Monto depositado',
            missingValue: 'Valor que Falta',
            cancel: 'Cancelar',
            payment: 'Pago',
            receipt: 'Recibimiento',
            toDeposit: 'A Depositar',
            accounted: 'Contabilizado',
            start: 'Comienzo',
            final: 'El fin',
            opening_interval: 'Intervalo de Apertura',
            apply: 'Aplicar',
            transfer_of_cashier: 'Transferencia de Caja',
            transfer: 'Transferir',
            transfer_cashier: 'Transferencia de Caja',
            search: 'Buscar',
            print: 'Imprimir',
            cashier: 'Caja',
            are_you_sure_you_want_to_transfer_cashier_to_this_selected_cashier:
                '¿Está seguro que desea transferir la caja a esta caja seleccionada?',
            please_select_cashier: 'Por favor seleccione una caja',
            cashier_transferred: 'Caja transferida',
        },
        BILLET: {
            start: 'Inicio',
            final: 'Final',
            cancel: 'Cancelar',
            apply: 'Aplicar',
            due_date_range: 'Rango de fecha de vencimiento',
            period: 'Periodo',
            service: 'Servicio',
            clear: 'Claro',
            search: 'Buscar',
            thereIsNoDataToLoad: 'No hay datos para cargar',
            contract: 'Contrato',
            student: 'Estudiante',
            number: 'Número',
            dueDate: 'Fecha de vencimiento',
            value: 'Valor',
            alter: 'Alterar',
            filters: 'Filtros',
            changes: 'Cambios',
            new_due_date: 'Nueva fecha de vencimiento',
            alter_all: 'Modificar todo',
            alter_selecteds: 'Modificar seleccionados',
            due_date_in_batches: 'Fecha de vencimiento en lotes',
            confirmation_of_alteration: 'Confirmación de alteración',
            are_you_sure_you_want_to_change_expiration_date:
                '¿Está seguro de que desea cambiar la fecha de vencimiento',
            of_all_filtered_bills: 'de todas las facturas filtradas',
            of_the_selected_bills: 'de las facturas seleccionadas',
            expiration_date_successfully_changed: 'La fecha de vencimiento se modificó correctamente',
            registered: 'Registrado',
            discounts_will_accompany_change: 'Los descuentos acompañarán al cambio',
            discount: 'Descuento',
            wait_for_processing: 'Espere a que se procese',
        },
        GENERAL: {
            yes: 'Si',
            no: 'No',
        },
        FILEGENERATE: {
            dueDate: 'Fecha de Vencimiento',
            billetNumber: 'N° Factura',
            billetCode: 'Código de Boleto',
            ourNumber: 'Nuestro Numero',
            responsible: 'Responsable',
            beneficiary: 'Beneficiario',
            value: 'Valor',
            dateRequested: 'Fecha de Solicitud',
            status: 'Tipo de Cambio',
        },
        STATUSRETURNLINE: {
            standby: 'En espera',
            sheduled: 'Programado',
            enqueued: 'En cola',
            awaiting: 'Esperando',
            proccessing: 'Procesando',
            success: 'Exitoso',
            failed: 'Fallado',
            deleted: 'Eliminado',
            accounted: 'Contabilizado',
            pendency: 'Pendencia',
            all: 'Todos',
        },
        AUDITRETURNFILE: {
            delete_with_successful: 'Ítem eliminado satisfactoriamente!',
            items_with_valores_duplicates: 'Existen items con valores duplicados. Por favor elimine item incorrecto! ',
            error_to_delete: 'Error al eliminar!',
        },
        JournalType: {
            All: 'Todos',
            AccountsPayable: 'Contas a Pagar',
            Provision: 'Provisionamento',
            AnticipatedRevenue: 'Receita Antecipada',
            Receiving: 'Recebimento',
            Payment: 'Pagamento',
            Remittance: 'Remessa',
            CheckTransit: 'Cheque',
            Imported: 'Importado',
            Uncollectible: 'Incobrável',
            CardTransit: 'Cartão',
            Payment_Cashier: 'Pago/Caja',
            Receiving_Cashier: 'Recibir/Caja',
            Receiving_WebPayment: 'Recibir/Web Pago',
            Pix: 'Pix',
            Receiving_Pix: 'Recibir/Pix',
            Receiving_Migration: 'Recibir/Migración',
            Receiving_EarlyReceiving: 'Recibir/Recibir Anticipado',
            Receiving_RecurringCard: 'Recibir/Tarjeta Recurrente',
            Remittance_Cashier: 'Remesa/Caja',
            Receiving_Bank: 'Recibir/Banco',
            Deposit_Cashier: 'Depósito/Caja',
        },
        JournalStatus: {
            All: 'Todos',
            0: 'Exportar',
            None: 'Ninguno',
            Awaiting: 'Aguardando',
            Success: 'Exportado',
            CreationError: 'Erro na Criação',
            ExportError: 'Erro na exportação',
        },
        JournalErrors: {
            AccountNotFound: 'Conta não encontrada',
            SubAccountNotFound: 'Sub Conta não encontrada',
            FunctionNotFound: 'Departamento não encontrada',
            FundNotFound: 'Fundo não encontrada',
            RestrictionNotFound: 'Retrição não encontrada',
            EntityNotFound: 'Entidade não encontrada',
            OpenAccountingMonthNotFound: 'Nenhum mês contábil aberto foi encontrado',
        },
        Data: 'Fecha',
        'Tipo de Lote': 'Tipo de Lote',
        Itens: 'Artículos',
        Mês: 'Mes',
        Ano: 'Año',
        Número: 'Número',
        'Nome de Usuário': 'Nombre de usuario',
        Status: 'Estado',
        'Cod. Escola': 'Cod. Colegio',
        Aluno: 'Estudiante',
        Responsável: 'Responsable',
        Parcela: 'Nº Pagos',
        Bandeira: 'Procesadores de Pago',
        'Nº Cartão': 'Nº Tarjeta',
        Valor: 'Valor',
        Vencimento: 'Vencimento',
        ReturnCode: 'Código de Retorno',
    },
};
